"use client";

import useEmblaCarousel from "embla-carousel-react";
import TestimonialCard from "../ui/TestimonialCard";
import Autoplay from "embla-carousel-autoplay";
import Image from "next/image";
import { SanityTalentStory } from "@/sanity/lib/types";
import { urlFor } from "@/sanity/lib/image";

export default function TalentStoriesHero({
  stories,
}: {
  stories: SanityTalentStory[];
}) {
  const [emblaRef] = useEmblaCarousel(
    {
      loop: true,
      duration: 80,
      align: "start",
    },
    [Autoplay({ delay: 8000, playOnInit: true })],
  );

  return (
    <section className="selection:!bg-accent relative z-10 mx-auto mb-20 max-w-300 overflow-x-hidden px-6 pt-30 lg:mb-45 lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-10 lg:gap-y-0 lg:pt-40">
      <div className="relative z-10 w-full text-center lg:min-w-0 lg:text-left">
        <div className="text-accent mb-4 text-6xl font-extrabold uppercase md:text-7xl lg:text-9xl">
          Journeys That Inspire
        </div>
        <p className="mx-auto max-w-xl lg:mx-0">
          Behind every internship, job, or line of code is a human story of
          resilience, learning, and hope. These are their journeys.
        </p>
      </div>
      <div className="relative mt-10 hidden min-w-0 w-full lg:mt-6 lg:block">
        <div className="w-full overflow-hidden" ref={emblaRef}>
          <div className="flex touch-pan-y">
            {stories
              ?.slice()
              .reverse()
              .map((testimonial) => (
                <div className="max-w-lg shrink-0 grow-0" key={testimonial._id}>
                  <TestimonialCard
                    name={testimonial.name}
                    quote={testimonial.quote}
                    photoUrl={urlFor(testimonial.photo).width(180).height(180).url()}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="absolute inset-0 z-[1] hidden lg:hidden">
        <Image
          src="/shapes/group-43.svg"
          alt="shape"
          width={100}
          height={100}
          className="absolute top-1/5 right-1/10 h-auto w-25"
        />
      </div>
    </section>
  );
}
